import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import type { LoyaltyOffersHubOffer } from 'loyalty/lib/loyaltyOffersHub/types'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LoyaltyOffersHubOfferCard from './LoyaltyOffersHubOfferCard'

const NON_DESKTOP_PAGE_SIZE = 4

const OffersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: ${rem(16)};
  row-gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: ${rem(24)};
    row-gap: ${rem(32)};
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`

const LoadMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: ${rem(8)};
`

interface Props {
  offers: Array<LoyaltyOffersHubOffer>
}

function renderOfferCard(offer: LoyaltyOffersHubOffer) {
  return <LoyaltyOffersHubOfferCard
    key={`${offer.offerTag}-${offer.title}-${offer.ctaUrl}`}
    offer={offer}
  />
}

function LoyaltyOffersHubOfferGrid({ offers }: Props) {
  const intl = useIntl()
  const [visibleNonDesktopOfferCount, setVisibleNonDesktopOfferCount] = useState(NON_DESKTOP_PAGE_SIZE)

  useEffect(() => {
    setVisibleNonDesktopOfferCount(NON_DESKTOP_PAGE_SIZE)
  }, [offers])

  const nonDesktopOffers = useMemo(
    () => offers.slice(0, visibleNonDesktopOfferCount),
    [offers, visibleNonDesktopOfferCount],
  )
  const hasMoreNonDesktopOffers = visibleNonDesktopOfferCount < offers.length

  const handleLoadMore = useCallback(() => {
    setVisibleNonDesktopOfferCount(count => Math.min(count + NON_DESKTOP_PAGE_SIZE, offers.length))
  }, [offers.length])

  return <>
    <CSSBreakpoint max="tablet">
      <Group direction="vertical" gap={16}>
        <OffersGrid>
          {nonDesktopOffers.map(renderOfferCard)}
        </OffersGrid>
        {hasMoreNonDesktopOffers && <LoadMoreButtonContainer>
          <TextButton kind="primary" onClick={handleLoadMore}>
            {intl.formatMessage({
              id: '-lotZ9ZX2pSrhcbLCfXS',
              defaultMessage: 'Load more',
              description: 'Button label to reveal more Societe offers on mobile and tablet',
            })}
          </TextButton>
        </LoadMoreButtonContainer>}
      </Group>
    </CSSBreakpoint>
    <CSSBreakpoint min="desktop">
      <OffersGrid>
        {offers.map(renderOfferCard)}
      </OffersGrid>
    </CSSBreakpoint>
  </>
}

export default LoyaltyOffersHubOfferGrid
